const FAILURE_REASON_KEYS = {
  DOMAIN_UNREACHABLE: {
    content: 'accessibility-wizard.scan-fail.DOMAIN_UNREACHABLE.content',
    title: 'accessibility-wizard.scan-fail.DOMAIN_UNREACHABLE.title',
    tooltip: 'accessibility-wizard.scan-fail.DOMAIN_UNREACHABLE.tooltip'
  },
  NO_PAGES_FOUND: {
    content: 'accessibility-wizard.scan-fail.NO_PAGES_FOUND.content',
    title: 'accessibility-wizard.scan-fail.NO_PAGES_FOUND.title'
  },
  PAGE_ACCESS_DENIED: {
    content: 'accessibility-wizard.scan-fail.PAGE_ACCESS_DENIED.content',
    primaryButtonText: 'accessibility-wizard.scan-fail.PAGE_ACCESS_DENIED.primary-button',
    title: 'accessibility-wizard.scan-fail.PAGE_ACCESS_DENIED.title',
    tooltip: 'accessibility-wizard.scan-fail.PAGE_ACCESS_DENIED.tooltip'
  },
  SCAN_TIMEOUT: {
    content: 'accessibility-wizard.scan-fail.SCAN_TIMEOUT.content',
    title: 'accessibility-wizard.scan-fail.SCAN_TIMEOUT.title'
  },
  SITE_DELETED: {
    content: 'accessibility-wizard.scan-fail.SITE_DELETED.content',
    primaryButtonText: 'accessibility-wizard.scan-fail.SITE_DELETED.primary-button',
    title: 'accessibility-wizard.scan-fail.SITE_DELETED.title',
    tooltip: 'accessibility-wizard.scan-fail.SITE_DELETED.tooltip'
  }
};
export function getScanFailureContent(t, reason) {
  const keys = reason ? FAILURE_REASON_KEYS[reason] : undefined;
  if (!keys) {
    return {
      content: t('accessibility-wizard.scan-fail.error-modal.content'),
      title: t('accessibility-wizard.scan-fail.error-modal.title'),
      tooltip: t('accessibility-wizard.rule-group.issue-count-badge.tooltip-content.scan-failed')
    };
  }
  return {
    content: t(keys.content),
    primaryButtonText: keys.primaryButtonText ? t(keys.primaryButtonText) : undefined,
    title: t(keys.title),
    tooltip: keys.tooltip ? t(keys.tooltip) : t('accessibility-wizard.rule-group.issue-count-badge.tooltip-content.scan-failed')
  };
}
//# sourceMappingURL=get-scan-failure-message.js.map